import { render, staticRenderFns } from "./StepIndicator.vue?vue&type=template&id=45c4c059&scoped=true&"
import script from "./StepIndicator.vue?vue&type=script&lang=js&"
export * from "./StepIndicator.vue?vue&type=script&lang=js&"
import style0 from "./StepIndicator.vue?vue&type=style&index=0&id=45c4c059&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c4c059",
  null
  
)

export default component.exports